import FormJaivana from "dashboard_jaivana_v1";

/**
 *
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */

class CustomAprobacionDeProduction extends FormJaivana.form {
  constructor(props) {
    super(props);
    this.initForm = this.initForm.bind(this);
    this.successDatosFicha = this.successDatosFicha.bind(this);
    this.successTablaItemFichas = this.successTablaItemFichas.bind(this);
    this.setButtonVer = this.setButtonVer.bind(this);
    this.verEspecification = this.verEspecification.bind(this);
    this.successTablaEtapas = this.successTablaEtapas.bind(this);
    this.gridOptionsTbEtapas = Object.assign({}, this.gridOptions);
    this.id_ficha = 0;
    this.setCantidadAgregada = this.setCantidadAgregada.bind(this);
    this.cantidadAgregadaChange = this.cantidadAgregadaChange.bind(this);
    this.succesGuardarValor = this.succesGuardarValor.bind(this);
    this.uploadTableEtapas = this.uploadTableEtapas.bind(this);
    this.uploadTableKg = this.uploadTableKg.bind(this);
    this.id_etapa = 0;
    this.successResultadoProduccion =
      this.successResultadoProduccion.bind(this);
    this.gridOptionsCostosProduccionTotales = Object.assign(
      {},
      this.gridOptions
    );
    this.gridOptionsTbProd = Object.assign({}, this.gridOptions);
    this.successResultadoEnvasado = this.successResultadoEnvasado.bind(this);
    this.gridOptionsTbEnv = Object.assign({}, this.gridOptions);
    this.successResultadosTotales = this.successResultadosTotales.bind(this);
    this.gridOptionsResTotal = Object.assign({}, this.gridOptions);
    this.successAnalisisGalones = this.successAnalisisGalones.bind(this);
    this.gridOptionsGalones = Object.assign({}, this.gridOptions);
    // this.successAnalisisCostos = this.successAnalisisCostos.bind(this);
    this.gridOptionsAnalizaCostos = Object.assign({}, this.gridOptions);
    this.successCostosTotales = this.successCostosTotales.bind(this);
    this.gridOptionsCostoTotal = Object.assign({}, this.gridOptions);
    this.successDevMateriaPrima = this.successDevMateriaPrima.bind(this);
    this.gridOptionsMateriaPrima = Object.assign({}, this.gridOptions);
    this.successDevMaterialEmpaque = this.successDevMaterialEmpaque.bind(this);
    this.gridOptionsMatEmpaque = Object.assign({}, this.gridOptions);
    this.uploadInforResultados = this.uploadInforResultados.bind(this);
    this.terminarProcesoAprobacion = this.terminarProcesoAprobacion.bind(this);
    this.costosTotalesProduccion = this.costosTotalesProduccion.bind(this);
    this.successCostosTotalesProd = this.successCostosTotalesProd.bind(this);
    this.formato = this.formato.bind(this);
    this.formato_costo_reales = this.formato_costo_reales.bind(this);
    this.formato_diferencia = this.formato_diferencia.bind(this);
    this.formato_variacion = this.formato_variacion.bind(this);
    this.traerDatosFicha = this.traerDatosFicha.bind(this);
    this.traerAnalisisKg = this.traerAnalisisKg.bind(this);
    this.formato2CostoTeorico = this.formato2CostoTeorico.bind(this);
    this.formato2CostoReales = this.formato2CostoReales.bind(this);
    this.formato2Diferencia = this.formato2Diferencia.bind(this);
    this.formato2Rendimiento = this.formato2Rendimiento.bind(this);
    this.formatoTotalesPrecioUnit = this.formatoTotalesPrecioUnit.bind(this);
    this.formatoTotalesPrecioTot = this.formatoTotalesPrecioTot.bind(this);
    this.formatoPrecioCostoDev     = this.formatoPrecioCostoDev.bind(this);
    this.verFormula = this.verFormula.bind(this);
    this.successVerFormula = this.successVerFormula.bind(this);
    this.gridOptionsVerFormula = Object.assign({}, this.gridOptions);
    this.successClose           = this.successClose.bind(this);
  }

  initForm() {
    console.log("Aprobación Producción @Version:1.01.0054 @Author: Mario A. Sepúlveda; @updateBy Sebastian Rios Echverri");
    this.getField("btnTerminar").setClick(this.terminarProcesoAprobacion);
    this.id_ficha = this.props.data.id_ficha;
    this.costosTotalesProduccion();
    this.traerDatosFicha();
    this.traerAnalisisKg();
    this.uploadInforResultados();
    this.getField('btn_verformula').setClick(this.verFormula);
  }

  verFormula(){
    let datos = {
        datos:{
            value: this.props.data.id_ficha,
        }
    }

    this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successVerFormula,
        error: this.error_,
        showMessage: false,
        general: this.generalFormatPmv
    });
  }

  successVerFormula(data){
    if (data.estado_p === 200 && data.data.length >= 1) {
      this.getField('modal_verformula').handleClickOpen();
      this.getField('tb_verformula').toggle(true);
      this.gridOptionsVerFormula['rowData'] = data.model;
      let configCell = new Map();
      configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
      configCell.set('version',{headerName: 'Versión'});
      configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
      configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
      this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
    }else if (data.estado_p === 404){
      this.alertGeneral.toggle(true,'No hay datos',"error");
      this.getField('tb_verformula').toggle(true);
      this.getField('modal_verformula').handleClose();
    }else{
      this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
      this.getField('tb_verformula').toggle(true);
      this.getField('modal_verformula').handleClose();
    }
  }
  
  traerDatosFicha() {
    let datos = {
        datos:{
            value: this.id_ficha, 
        }
    }

    this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successDatosFicha,
        error: this.error_,
        general: this.generalFormatPmv
    });

    /*this.generalFormat.nombre_accion =
      "457-servicio_produccion_fichas_traer_datos_fichas"; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
    this.service.send({
      endpoint: this.constant.formConfiguration(),
      method: "GET",
      body: bodys,
      success: this.successDatosFicha,
      error: this.error_,
      general: this.generalFormat,
      showMessage :false
    });*/
  }
  traerAnalisisKg() {
    let datos = {
      datos:{
        value: this.props.data.id_ficha,
      }
    };

    this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'analisiskg', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successTablaItemFichas,
        error: this.error_,
        general: this.generalFormatPmv
    });

    /*this.generalFormat.nombre_accion =
      "457-servicio_produccion_fichas_items_traer_tabla_analisiskg"; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
    this.service.send({
      endpoint: this.constant.formConfiguration(),
      method: "GET",
      body: body,
      success: this.successTablaItemFichas,
      error: this.error_,
      general: this.generalFormat,
      showMessage :false
    });*/
  }

  successDatosFicha(data) {
    let datosFicha = [];
    if (
      data.estado_p === 200 &&
      data.model !== undefined &&
      data.model.length > 0
    ) {
      this.getField("listaAprobProd").setVisible(true);
      datosFicha.push(data.data[0]);
      this.getField("listaAprobProd").setItemsFichas(datosFicha);
    } else {
      this.getField("listaAprobProd").setVisible(false);
    }
  }

  successTablaItemFichas(data) {
    if (data.estado_p === 200) {
      let configCell = new Map();
      configCell.set(0, { cellRenderer: this.setButtonVer, field: "accion" });
      this.gridOptions["rowData"] = data.model;
      this.getField("tablaAprobProd").initData(this.gridOptions, configCell);
    } else {
      this.getField("tablaAprobProd").toggle(false);
    }
  }

  setButtonVer(props) {
    //let id = props.data.id;
    let etapa_id = props.data.etapa_id;
    let nombre_etapa = props.data.nombre_etapa;

    let button = document.createElement("input");
    button.onclick = () => this.verEspecification(etapa_id, nombre_etapa);
    button.setAttribute("id", "button_delete_" + etapa_id);
    button.setAttribute("class", "buttonStyle"); //,"width:100%; height: 100%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
    button.setAttribute("type", "button");
    button.setAttribute("value", "Ver");
    return this.createElementJaivana(button);
  }

  verEspecification(etapa_id, nombre_etapa) {
    this.getField("modalAprobProdEtapas").handleClickOpen();
    this.getField("etapas").setValue(nombre_etapa);
    this.getField("listaEtapasAprobprod").setVisible(false);
    this.id_etapa = etapa_id;

    let datos = {
      datos:{
        produccion_fichas_id: this.id_ficha,
        etapa_id: etapa_id,
      }
    };

    this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'itemsetapa', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successTablaEtapas,
        error: this.error_,
        general: this.generalFormatPmv
    });

    // 
    /*this.generalFormat.nombre_accion =
      "457-servicio_produccion_fichas_items_btn_ver_etapas"; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
    this.service.send({
      endpoint: this.constant.formConfiguration(),
      method: "GET",
      body: body,
      success: this.successTablaEtapas,
      error: this.error_,
      general: this.generalFormat,
      showMessage :false
    });*/
  }

  successResultadoProduccion(data) {
    if (data.estado_p === 200) {
      this.getField("resultadoProdTB").toggle(true);
      //this.gridOptionsTbProd['rowData'] = [];

      //this.getField('resultadoProdTB').initData(this.gridOptionsTbProd);
      let configCellcol = new Map();
      this.gridOptionsTbProd["rowData"] = data.data;
      this.getField("resultadoProdTB").initData(
        this.gridOptionsTbProd,
        configCellcol
      );
    } else {
      this.getField("resultadoProdTB").toggle(false);
    }
  }

  successResultadoEnvasado(data) {
    if (data.estado_p === 200) {
      this.getField("resultadoEnvTB").toggle(true);
      //this.gridOptionsTbEnv['rowData'] = [];
      //this.getField('resultadoEnvTB').initData(this.gridOptionsTbEnv);
      let configCellcol = new Map();
      this.gridOptionsTbEnv["rowData"] = data.data;
      this.getField("resultadoEnvTB").initData(
        this.gridOptionsTbEnv,
        configCellcol
      );
    } else {
      this.getField("resultadoEnvTB").toggle(false);
    }
  }

  successResultadosTotales(data) {
    if (data.estado_p === 200) {
      this.getField("resultadoTotalTB").toggle(true);
      //this.gridOptionsResTotal['rowData'] = [];
      //this.getField('resultadoTotalTB').initData(this.gridOptionsResTotal);
      let configCellcol = new Map();
      this.gridOptionsResTotal["rowData"] = data.data;
      this.getField("resultadoTotalTB").initData(
        this.gridOptionsResTotal,
        configCellcol
      );
    } else {
      this.getField("resultadoTotalTB").toggle(false);
    }
  }

  successAnalisisGalones(data) {
    if (data.estado_p === 200) {
      this.getField("analisisGalonesTB").toggle(true);
      //this.gridOptionsGalones['rowData'] = [];
      //this.getField('analisisGalonesTB').initData(this.gridOptionsGalones);
      let configCellcol = new Map();
      this.gridOptionsGalones["rowData"] = data.data;
      this.getField("analisisGalonesTB").initData(
        this.gridOptionsGalones,
        configCellcol
      );
    } else {
      this.getField("analisisGalonesTB").toggle(false);
    }
  }

  formato(props) {
    return "".formatoPrecio(props.data.costo_teorico);
  }

  formato_costo_reales(props) {
    return "".formatoPrecio(props.data.costo_reales);
  }

  formato_diferencia(props) {
    return "".formatoPrecio(props.data.diferencia);
  }

  formato_variacion(props) {
    return "".formatoPrecio(props.data.variacion);
  }

  formato2CostoTeorico(props) {
    return "".formatoPrecio(props.data.costo_teorico);
  }

  formato2CostoReales(props) {
    return "".formatoPrecio(props.data.costo_reales);
  }

  formato2Diferencia(props) {
    return "".formatoPrecio(props.data.diferencia);
  }

  formato2Rendimiento(props) {
    return "".formatoPrecio(props.data.rendimiento);
  }

  successCostosTotales(data) {
    if (data.estado_p === 200) {
      this.getField("costosTotalesTB").toggle(true);
      //this.gridOptionsCostoTotal['rowData'] = [];
      //this.getField('costosTotalesTB').initData(this.gridOptionsCostoTotal);
      let configCellcol = new Map();
      this.gridOptionsCostoTotal["rowData"] = data.data;
      configCellcol.set("costo_teorico", {
        cellRenderer: this.formato2CostoTeorico,
        cellStyle: { textAlign: "right" },
        field: "costo_teorico",
      });
      configCellcol.set("costo_reales", {
        cellRenderer: this.formato2CostoReales,
        cellStyle: { textAlign: "right" },
        field: "costo_reales",
      });
      configCellcol.set("diferencia", {
        cellRenderer: this.formato2Diferencia,
        cellStyle: { textAlign: "right" },
        field: "diferencia",
      });
      configCellcol.set("rendimiento", {
        cellRenderer: this.formato2Rendimiento,
        cellStyle: { textAlign: "right" },
        field: "rendimiento",
      });

      this.getField("costosTotalesTB").initData(
        this.gridOptionsCostoTotal,
        configCellcol
      );
    } else {
      this.getField("costosTotalesTB").toggle(false);
    }
  }

  successDevMateriaPrima(data) {
    if (data.estado_p === 200) {
      this.getField("devMateriaPrimaTB").toggle(true);
      //this.gridOptionsMateriaPrima['rowData'] = [];
      //this.getField('devMateriaPrimaTB').initData(this.gridOptionsMateriaPrima);
      let configCellcol = new Map();

      configCellcol.set("costo", {
        cellRenderer: this.formatoPrecioCostoDev,
        editable: true,
        field: "costo",
      });
      this.gridOptionsMateriaPrima["rowData"] = data.data;
      this.getField("devMateriaPrimaTB").initData(
        this.gridOptionsMateriaPrima,
        configCellcol
      );
    } else {
      this.getField("devMateriaPrimaTB").toggle(false);
    }
  }

  formatoPrecioCostoDev(props) {
    return "".formatoPrecio(props.data.costo);
  }

  successDevMaterialEmpaque(data) {
    if (data.estado_p === 200) {
      this.getField("devMaterialEmpaqueTB").toggle(true);
      //this.gridOptionsMatEmpaque['rowData'] = [];
      //this.getField('devMaterialEmpaqueTB').initData(this.gridOptionsMatEmpaque);
      let configCellcol = new Map();
      this.gridOptionsMatEmpaque["rowData"] = data.data;
      this.getField("devMaterialEmpaqueTB").initData(
        this.gridOptionsMatEmpaque,
        configCellcol
      );
    } else {
      this.getField("devMaterialEmpaqueTB").toggle(false);
    }
  }

  successTablaEtapas(data) {
    if (data.estado_p === 200) {
      let configCellcol = new Map();
      configCellcol.set("cantidad_agregada", {
        cellRenderer: this.setCantidadAgregada,
        singleClickEdit: true,
        cellStyle: { backgroundColor: "rgb(238,238,238)", borderRadius: "5px" },
        onCellValueChanged: this.cantidadAgregadaChange,
        width: 150,
        editable: true,
        field: "cantidad_agregada",
      });
      this.gridOptionsTbEtapas["rowData"] = data.data;
      this.getField("tablaEtapasAprobProd").initData(
        this.gridOptionsTbEtapas,
        configCellcol
      );
    } else {
      this.getField("tablaEtapasAprobProd").toggle(false);
    }
  }

  setCantidadAgregada(props) {
    let valor_actual = props.data.cantidad_agregada;
    let div = document.createElement("div");
    let label = document.createElement("label");
    label.textContent = valor_actual;
    div.appendChild(label);
    return this.createElementJaivana(div);
  }

  cantidadAgregadaChange(props) {
    let seguir = this.getField("tablaEtapasAprobProd").cellValid(
      props.oldValue,
      props.newValue,
      "^[0-9]"
    );
    if (seguir) {
      if (props.oldValue !== props.newValue) {
        let id = props.data.id;
        let valuee = String(props.newValue);
        if (valuee !== "") {
          console.log("Propssss == ",valuee);

          let datos = {
            datos:{
              cantidad_agregada: parseFloat(valuee).toFixed(4),
              actividad_id:this.props.data.actividad_id,
              etapa_id: this.id_etapa,
              id: id,
            }
          };

          this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'cantidad_agregada', operacion_tipo: 'modificar' };
          this.service.send(
          {
              endpoint: this.constant.formConfiguration(),
              method:'PUT',
              body: datos,
              success: this.succesGuardarValor,
              error: this.error_,
              general: this.generalFormatPmv
          });
        } else {
          props.data.valor_actual = 0;
          this.getField("fieldAlert").toggle(
            true,
            "El campo no cumple con el formato deseado",
            "error"
          );
        }
      }
    }
  }

  succesGuardarValor(data) {
    if (data.estado_p === 200) {
      this.uploadTableEtapas();
      this.uploadTableKg();
      this.uploadInforResultados();
    }
  }

  uploadTableKg() {
    let datos = {
      datos:{
        value: this.props.data.id_ficha,
      }
    };

    this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'analisiskg', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successTablaItemFichas,
        error: this.error_,
        general: this.generalFormatPmv
    });
    /*let body = {
      value: this.id_ficha,
    };
    this.generalFormat.nombre_accion =
      "457-servicio_produccion_fichas_items_traer_tabla_analisiskg"; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
    this.service.send({
      endpoint: this.constant.formConfiguration(),
      method: "GET",
      body: body,
      success: this.successTablaItemFichas,
      error: this.error_,
      general: this.generalFormat,
      showMessage :false
    });*/
  }

  uploadTableEtapas() {
    let datos = {
      datos:{
        produccion_fichas_id: this.id_ficha,
        etapa_id: this.id_etapa,
      }
    };

    this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'itemsetapa', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successTablaEtapas,
        error: this.error_,
        general: this.generalFormatPmv
    });

    /*let body = {
      produccion_fichas_id: this.id_ficha,
      etapa_id: this.id_etapa,
    };
    this.generalFormat.nombre_accion =
      "457-servicio_produccion_fichas_items_btn_ver_etapas"; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
    this.service.send({
      endpoint: this.constant.formConfiguration(),
      method: "GET",
      body: body,
      success: this.successTablaEtapas,
      error: this.error_,
      general: this.generalFormat,
      showMessage :false
    });*/
  }

  uploadInforResultados() {
    let datos = {
      datos:{
        value: this.id_ficha,
      }
    };

    this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'resultadoproduccion', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successResultadoProduccion,
        error: this.error_,
        general: this.generalFormatPmv
    });

    this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'resultadoenvasado', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successResultadoEnvasado,
        error: this.error_,
        general: this.generalFormatPmv
    });

    this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'resultadototal', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successResultadosTotales,
        error: this.error_,
        general: this.generalFormatPmv
    });

    this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'analisisgalones', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successAnalisisGalones,
        error: this.error_,
        general: this.generalFormatPmv
    });

    this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'costostotales', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successCostosTotales,
        error: this.error_,
        general: this.generalFormatPmv
    }); 


    this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'resumen_devolucion_materiaprima', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successDevMateriaPrima,
        error: this.error_,
        general: this.generalFormatPmv
    }); 

    this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'resumen_devolucion_materialempaque', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successDevMaterialEmpaque,
        error: this.error_,
        general: this.generalFormatPmv
    }); 
  }

  terminarProcesoAprobacion() {
    this.getField("produccion_fichas_id").setValue(this.props.data.id_ficha);
    this.getField("proceso_id").setValue(this.props.data.proceso_id);
    this.getField("actividad_id").setValue(this.props.data.actividad_id);
    this.getField("actividad_configuracion_id").setValue(
      this.props.data.actividad_configuracion_id
    );

    if (
      this.getField("observacion").getValue() !== "" &&
      this.getField("observacion").getValue() !== " "
    ) {
      this.getField("observacion").setError(false, "");
      this.getField("btnTerminar").setDisabled(true);
      this.mostrarMensajeGenerando();

      let datos = {
        datos:{
          id_formulario: this.formId,
          produccion_fichas_id: this.getField("produccion_fichas_id").getValue(),
          proceso_id: this.getField("proceso_id").getValue(),
          actividad_id: this.getField("actividad_id").getValue(),
          actividad_configuracion_id: this.getField("actividad_configuracion_id").getValue(),
          observacion: this.getField("observacion").getValue(),
        }
      };

      this.generalFormatPmv = { tipo_servicio: 'prod-fichasrecepciondevolucion', operacion: 'crear', operacion_tipo: 'crear' };
      this.service.send(
      {
          endpoint: this.constant.formConfiguration(),
          method:'POST',
          body: datos,
          success: this.successClose,
          error: this.error_,
          general: this.generalFormatPmv
      }); 

      /*this.generalFormat.nombre_accion =
        "457-Permite_pasar_a_la_actividad_de_recepcion_de_devolucion";
      this.service.send({
        endpoint: this.constant.formConfiguration(),
        method: "POST",
        body: body,
        success: this.successCloseEstage,
        error: this.error_,
        general: this.generalFormat,
      });*/
    } else {
      this.getField("observacion").setError(true, "Este campo es requerido");
    }
  }

  successClose(data){
    this.getField('confirmModalCustom').toggle(false);
    this.getField("btnTerminar").setDisabled(false);
    this.successCloseEstage(data);
  }

  mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
  }

  costosTotalesProduccion() {
    let datos = {
      datos:{
        value: this.id_ficha,
      }
    };

    this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'costostotalesproduccion', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successCostosTotalesProd,
        error: this.error_,
        general: this.generalFormatPmv
    });
    /*this.generalFormat.nombre_accion =
      "457-produccion_fichas-costostotalesproduccion";
    this.service.send({
      endpoint: this.constant.formConfiguration(),
      method: "GET",
      body: body,
      success: this.successCostosTotalesProd,
      error: this.error_,
      general: this.generalFormat,
    });*/
  }
  successCostosTotalesProd(data) {
    if (data.estado_p === 200) {
      //costos_totales_produccion
      let configCell = new Map();
      configCell.set("precio_unitario", {
        cellRenderer: this.formatoTotalesPrecioUnit,
        editable: true,
        field: "precio_unitario",
      });
      configCell.set("precio_total", {
        cellRenderer: this.formatoTotalesPrecioTot,
        editable: true,
        field: "precio_total",
      });
      this.gridOptionsCostosProduccionTotales["rowData"] = data.data;
      this.getField("costos_totales_produccion").initData(
        this.gridOptionsCostosProduccionTotales,
        configCell
      );
      // this.getField("costos_totales_produccion").toggle(true);
    }
  }
  formatoTotalesPrecioUnit(props) {
    return "".formatoPrecio(props.data.precio_unitario);
  }
  formatoTotalesPrecioTot(props) {
    return "".formatoPrecio(props.data.precio_total);
  }
}

FormJaivana.addController("prod-aprobacionenvasado", CustomAprobacionDeProduction);

export default CustomAprobacionDeProduction;
